import { UserWrapper } from "./styled"
import NoAvatar from "assets/images/no-avatar.png"
import { Link, useNavigate } from "react-router-dom"
import { FaUserShield } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { authAction } from "redux/slice/authSlice"
import { useSelector } from "react-redux"
import { authSelector } from 'redux/selector'
import { role } from "common/general"
import { useRef } from "react";

const User = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const authState = useSelector(authSelector)
    const avatarRef = useRef()
    return (
        <UserWrapper>
            <div className="avatar">
                <img
                    src={authState.currentUser?.user?.avatar || NoAvatar}
                    alt="avatar"
                    onClick={() => !authState.isLoggedIn && navigate("/login")}
                    ref={avatarRef}
                    onError={() => avatarRef.current.src = NoAvatar}
                />
                {
                    authState.isLoggedIn &&
                    <ul className="avatar_suggestion">
                        <li className="avatar_suggestion_item">
                            <Link to="/my-page" className="text-link">
                                <i className="ti-user"></i>Tài khoản
                            </Link>
                        </li>
                        {
                            authState.role !== role.CUSTOMER &&
                            <li className="avatar_suggestion_item">
                                <Link to="/admin/customer" className="text-link">
                                    <i><FaUserShield /></i>Quản trị
                                </Link>
                            </li>
                        }
                        {
                            authState.role === role.CUSTOMER &&
                            <li className="avatar_suggestion_item">
                                <Link to="/favorite" className="text-link">
                                    <i className="ti-heart"></i>Yêu thích
                                </Link>
                            </li>
                        }
                        <li className="avatar_suggestion_item" onClick={() => dispatch(authAction.logout({ navigate }))}>
                            <span className="text-link">
                                <i className="ti-shift-right"></i>Đăng xuất
                            </span>
                        </li>
                    </ul>
                }
            </div>
        </UserWrapper>
    )
}

export default User